import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker'
import { Control, Controller, FieldError } from 'react-hook-form'
import { FormHelperText } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from 'date-fns/locale'

export interface DateTimePickerProps {
  name: string
  label: string
  className?: string
  disabled?: boolean
  control: Control<any>
  errorContent?: FieldError
  maxDateTime?: Date
}

const DateTimePicker = ({
  name,
  label,
  className = 'mt-3',
  control,
  errorContent,
  disabled,
  maxDateTime
}: DateTimePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <DesktopDateTimePicker
              {...field}
              disabled={disabled}
              label={label}
              className={className}
              value={field.value}
              onChange={field.onChange}
              maxDateTime={maxDateTime}
              slotProps={{
                textField: {
                  error: !!fieldState.error,
                  helperText: fieldState.error ? fieldState.error.message : '',
                  InputLabelProps: { shrink: true },
                  disabled: disabled,
                  InputProps: {
                    style: {
                      cursor: disabled ? 'not-allowed' : 'default'
                    }
                  }
                }
              }}
              format="dd/MM/yyyy HH:mm"
            />
            {errorContent && (
              <FormHelperText error={!!errorContent?.message}>
                {errorContent?.message}
              </FormHelperText>
            )}
          </>
        )}
      />
    </LocalizationProvider>
  )
}

export default DateTimePicker
